import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const RequestList = withAsync({
	loader: lazyForPaint(() =>
		import(/* webpackChunkName: "request-list" */ './hocs').then((module) => {
			const { registerRequestsListEpicsndReducers } = module;
			registerRequestsListEpicsndReducers();
			return module.default;
		}),
	),
});
